function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './ImageMultiSelect.css';
import React, { useState } from 'react';
import { get, getDictionaryItem } from '../../../../../utils';
import { addQueryStringMultiple, deleteQueryString } from '../../../../Listing/index';
import { useHistory } from 'react-router-dom';
import { SitecoreContextReactContext } from '../../../../../utils/SitecoreContextReactContext';
import { tealiumClickFunc, tealiumMergeClickData } from '../../../../../utils/tealium';
const ImageMultiSelect = _ref => {
  let {
    filter,
    imageDictionary,
    params,
    analytics,
    facets,
    dictionary,
    setFilter,
    facetsName,
    hits,
    clearAlllFilters,
    getFilterValue
  } = _ref;
  const [selectedMap, selectCard] = useState({});
  let history = useHistory();
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const toggleCard = (id, available) => () => {
    if (!available) {
      return;
    }
    tealiumClickFunc(tealiumMergeClickData(analytics.filterMeetingRoomLayoutAnalytics, params), id);
    const map = _objectSpread(_objectSpread({}, selectedMap), {}, {
      [id]: !selectedMap[id]
    });
    selectCard(map);
    const selected = Object.entries(map).filter(_ref2 => {
      let [v, s] = _ref2;
      return s;
    }).map(_ref3 => {
      let [v] = _ref3;
      return v;
    });
    getFilterValue && getFilterValue(filter.name, facetsName, map);
    addQueryStringMultiple(facetsName, map, history);
    setFilter();
  };
  React.useEffect(() => {
    if (clearAlllFilters) {
      deleteQueryString(facetsName, history);
      selectCard({});
      getFilterValue && getFilterValue(filter.name, facetsName, null);
    }
  }, [clearAlllFilters]);
  const mapDictionary = {
    'Banquet': 'banquet',
    'Boardroom': 'board room',
    'Cabaret': 'cabaret',
    'Classroom': 'class room',
    'Theatre': 'theatre',
    'UShape': 'u shape'
  };
  const mapImageDictionary = {
    'Banquet': 'search.banquetCapacity',
    'Boardroom': 'search.boardroomCapacity',
    'Cabaret': 'search.cabaretCapacity',
    'Classroom': 'search.classroomCapacity',
    'Theatre': 'search.theatreCapacity',
    'UShape': 'search.uShapeCapacity'
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: "cards__title"
  }, get(filter, 'title.jss.value', '')), /*#__PURE__*/React.createElement("div", {
    className: "cards filter__field image-multiselect"
  }, get(filter, 'fieldNameItems.items', []).map(_ref4 => {
    let {
      fieldName,
      fieldValue
    } = _ref4;
    var available = facets && facets[fieldValue.value] > 0;
    return /*#__PURE__*/React.createElement("div", {
      className: `card ${selectedMap[fieldValue.value] ? 'card--selected' : ''} ${!available ? 'card--not-available' : ''}`,
      onClick: toggleCard(fieldValue.value, available),
      tabIndex: 0,
      onKeyPress: event => {
        if (event.key === "Enter" || event.key === "NumpadEnter" || event.which === 32) {
          event.preventDefault();
          event.target.click();
        }
      }
    }, selectedMap[fieldValue.value] ? /*#__PURE__*/React.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "13.126",
      height: "11.425",
      viewBox: "0 0 13.126 11.425"
    }, /*#__PURE__*/React.createElement("path", {
      id: "Union_35",
      "data-name": "Union 35",
      d: "M2.2,10.161,2.032,10l0,0L0,7.96,1.413,6.545,3.424,8.557,11.688,0l1.438,1.39L4.865,10l.015.016L3.464,11.425Z",
      fill: "#fff"
    })) : null, /*#__PURE__*/React.createElement("div", {
      className: "card__img"
    }, selectedMap[fieldValue.value] ? /*#__PURE__*/React.createElement("img", {
      alt: getDictionaryItem(dictionary, mapDictionary[fieldValue.value]),
      src: get(getDictionaryItem(imageDictionary, `${mapImageDictionary[fieldValue.value]}.Active`), 'src')
    }) : /*#__PURE__*/React.createElement("img", {
      alt: getDictionaryItem(dictionary, mapDictionary[fieldValue.value]),
      src: get(getDictionaryItem(imageDictionary, mapImageDictionary[fieldValue.value]), 'src')
    })), getDictionaryItem(dictionary, mapDictionary[fieldValue.value]));
  })));
};
const StyledWrapper = _ref5 => {
  let {
    children,
    rtl
  } = _ref5;
  return /*#__PURE__*/React.createElement("div", {
    className: `${commonStyles} ${rtl ? rtlStyles : ltrStyles} col-12`
  }, children);
};
export default ImageMultiSelect;
const commonStyles = "cxvvsx4";
const ltrStyles = "l1oeyarc";
const rtlStyles = "r1ototgo";